<template>
  <div style="margin-top: 96px;padding: 48px 12px;" class="bg-light mt-5 py-3">
    <div class="footer">
      <b-row class="align-items-center">
        <b-col cols="12" md class="mb-2 mb-md-0 text-left">
          <img :src="require('../assets/logo.svg')" width="160.31px" height="auto" alt="Crypto.com Help Center"></img>
        </b-col>
        <b-col cols="12" md class="text-md-right">
          <!-- <span style="font-size: 13px;color: #929BA5;">Cookie Preferences</span> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
.footer img {
  filter: invert(0.1) sepia(0) saturate(0) hue-rotate(0deg) brightness(0.9);
}
</style>